import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ng-casto-collapsible-section',
  templateUrl: './collapsible-section.component.html',
  styleUrl: './collapsible-section.component.scss',
  animations: [
    trigger('expandCollapse', [
      state('open', style({
        height: '*',
        opacity: 1,
        paddingTop: '*',
        paddingBottom: '*',
        marginTop: '*',
        marginBottom: '*'
      })),
      state('closed', style({
        height: '0px',
        opacity: 0,
        paddingTop: '0',
        paddingBottom: '0',
        marginTop: '0',
        marginBottom: '0',
        overflow: 'hidden'
      })),
      transition('open <=> closed', [
        animate('300ms ease-in-out')
      ]),
      transition('void => *', [
        style({ height: '0px', opacity: 0 }),
        animate('300ms ease-out')
      ]),
      transition('* => void', [
        animate('300ms ease-in', style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class CollapsibleSectionComponent implements OnInit {
  @Input() title = '';
  @Input() defaultOpen = true;
  isOpen = true;

  ngOnInit(): void {
    this.isOpen = this.defaultOpen;
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
